import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import CallSign from 'components/CallSign';
import Style from './NetworkBubble.module.scss';

const NetworkBubble = ({ callSign = '', link = '', showNetworkIcon = false }) => {
  if (!callSign || !showNetworkIcon) return null;
  const networkLogoStyle = [Style.networkLogoBubble];

  return (
    <Link to={link} className={Style.networkLogoBubbleContainer}>
      <div className={classNames(networkLogoStyle)}>
        <div className={Style.networkLogoBubbleIcon}>
          <CallSign callSign={callSign} color="white" />
        </div>
      </div>
    </Link>
  );
};

export default NetworkBubble;

NetworkBubble.propTypes = {
  callSign: PropTypes.string,
  link: PropTypes.string,
  showNetworkIcon: PropTypes.bool,
};
